import React, { useMemo, useState } from "react";

const LanguageSearchSelect = ({ value, onChange, languages, idPrefix = "lang" }) => {
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const t = query.trim().toLowerCase();
    if (!t) return languages;
    return languages.filter((name) => name.toLowerCase().includes(t));
  }, [query, languages]);

  const pick = (lang) => {
    onChange(lang);
  };

  return (
    <div className="gf-lang-select">
      <input
        id={`${idPrefix}-search`}
        type="search"
        className="gf-input gf-lang-select__search"
        placeholder="Search languages…"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        autoComplete="off"
        aria-label="Search languages"
      />
      {value ? (
        <p className="gf-lang-select__picked">
          Selected: <strong>{value}</strong>
        </p>
      ) : null}
      <div className="gf-lang-select__list" role="listbox" aria-label="Language options">
        <button
          type="button"
          role="option"
          aria-selected={!value}
          className={`gf-lang-select__opt ${!value ? "is-active" : ""}`}
          onClick={() => pick("")}
        >
          Any language
        </button>
        {filtered.map((name) => (
          <button
            key={name}
            type="button"
            role="option"
            aria-selected={value === name}
            className={`gf-lang-select__opt ${value === name ? "is-active" : ""}`}
            onClick={() => pick(name)}
          >
            {name}
          </button>
        ))}
      </div>
      {query && filtered.length === 0 && (
        <p className="gf-lang-select__empty">No match — try another term.</p>
      )}
    </div>
  );
};

export default LanguageSearchSelect;
